import { render, staticRenderFns } from "./AditionalValueItem.vue?vue&type=template&id=9df24698&"
import script from "./AditionalValueItem.vue?vue&type=script&lang=js&"
export * from "./AditionalValueItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports